import {
    SET_TRACK_AUTOMATION_DEVICE,
    SET_PARAMETER_SLIDER_DOWN,
    SET_TRACK_AUTOMATION_SUB_DEVICE,
    MOVE_ENGINE_AUTOMATIONS,
    SET_TRACK_AUTOMATION_PARAMETER,
    SET_AUTOMATION_GUIDE_POINT,
    SET_AUTOMATION_POINT_DRAGGING,
    SET_AUTOMATION_POINT_HOVERED,
    SET_AUTOMATION_POINT_HAS_MOVED,
    SET_TRACK_AUTOMATION_RACK_DEVICE,
    SET_PARAMETER_AUTOMATIONS,
    SET_PARAMETER_MIX_AUTOMATIONS,
    DELETE_AUTOMATIONS_FOR_PARAMETERS,
    DELETE_AUTOMATIONS_FOR_ENGINE,
    SET_AUTOMATION_SELECTION,
    SET_AUTOMATION_POINTS_SELECTED,
    SET_SHOW_AUTOMATION,
       } from 'constants/action-types.js';

let initialState = {
    guidePoint: {},
    pointHovered: {},
    parameterSliderDown: [],
    pointHasMoved: {},
    pointsSelected: {},
    pointDragging: {},
    selection: {},
    parameterAutomations: {},
    automationSchedulers: {},
    parameterMixAutomations: {},
    automationMixSchedulers: {},
    trackDevice: {},
    trackSubDevice: {},
    trackRackDevice: {},
    trackParameter: {},
    show: false,
};

const automationReducer = (state = initialState, action) => {
    let newState;
    let parameter;
    let engineId;
    let parameterAutomations;
    let automationSchedulers
    let parameterMixAutomations;
    let automationMixSchedulers
    switch (action.type) {
    case SET_TRACK_AUTOMATION_DEVICE:
        let device= {... state.trackDevice};
        device[action.payload.trackId] = action.payload.device;
        parameter = {... state.trackParameter};
        parameter[action.payload.trackId] = undefined;
        return {
            ... state,
            trackDevice: device,
            trackParameter: parameter,
        };
    case SET_TRACK_AUTOMATION_RACK_DEVICE:
        let rackDevice = {... state.trackRackDevice};
        rackDevice[action.payload.trackId] = action.payload.device;
        return {
            ... state,
            trackRackDevice: rackDevice
        };
    case DELETE_AUTOMATIONS_FOR_ENGINE:
        parameterAutomations = {... state.parameterAutomations};
        automationSchedulers = {... state.automationSchedulers};
        delete parameterAutomations[action.payload];
        delete automationSchedulers[action.payload];
        return {
            ... state,
            parameterAutomations,
            automationSchedulers
        };
    case DELETE_AUTOMATIONS_FOR_PARAMETERS:
        // potential bug: parameters might be from different engines...
        if (action.payload.length === 0) {
            return state;
        }
        engineId = action.payload[0].sequencerEngine.sequenceId;

        parameterAutomations = state.parameterAutomations[engineId] || {};
        automationSchedulers = state.automationSchedulers[engineId] || {};

        action.payload.forEach(
            parameter => {
                delete parameterAutomations[parameter.id];
                delete automationSchedulers[parameter.id];
            });
        newState = {... state};
        newState.parameterAutomations[engineId] = parameterAutomations;
        newState.automationSchedulers[engineId] = automationSchedulers;
        return newState;
    case SET_TRACK_AUTOMATION_SUB_DEVICE:
        let subDevice = {... state.trackSubDevice};
        subDevice[action.payload.trackId] = action.payload.subDevice;
        parameter = {... state.trackParameter};
        parameter[action.payload.trackId] = undefined;
        return {
            ... state,
            trackSubDevice: subDevice,
            trackParameter: parameter,
        };
    case SET_TRACK_AUTOMATION_PARAMETER:
        parameter = {... state.trackParameter};
        parameter[action.payload.trackId] = action.payload.parameter;
        return {
            ... state,
            trackParameter: parameter
        };
    case SET_SHOW_AUTOMATION:
        return {
            ... state,
            show: action.payload.show,
        };
    case SET_PARAMETER_SLIDER_DOWN:
        return {
            ... state,
            parameterSliderDown: action.payload === undefined ? [] :
                Array.isArray(action.payload) ? action.payload :
                [action.payload]
        };
    case MOVE_ENGINE_AUTOMATIONS:
        parameterAutomations = {... state.parameterAutomations};
        automationSchedulers = {... state.automationSchedulers};
        automationMixSchedulers = {... state.automationMixSchedulers};
        parameterMixAutomations = {... state.parameterMixAutomations};

        parameterAutomations[action.payload.newId] = parameterAutomations[action.payload.oldId];
        automationSchedulers[action.payload.newId] = automationSchedulers[action.payload.oldId];
        parameterMixAutomations[action.payload.newId] = parameterMixAutomations[action.payload.oldId];
        automationMixSchedulers[action.payload.newId] = automationMixSchedulers[action.payload.oldId];

        delete parameterAutomations[action.payload.oldId];
        delete automationSchedulers[action.payload.oldId];
        delete automationMixSchedulers[action.payload.oldId];
        delete parameterMixAutomations[action.payload.oldId];
        return {
            ... state,
            automationSchedulers,
            parameterAutomations,
            automationMixSchedulers,
            parameterMixAutomations
        };
    case SET_PARAMETER_AUTOMATIONS:
        engineId = action.payload.parameter.sequencerEngine ?
            action.payload.parameter.sequencerEngine.sequenceId : 0;
        let __p = {... state.parameterAutomations};
        let __s = {... state.automationSchedulers};
        let _s = state.automationSchedulers[engineId] || {};
        let _p = state.parameterAutomations[engineId] || {};
        _s[action.payload.parameter.id] = action.payload.scheduler;
        _p[action.payload.parameter.id] = action.payload.automations;
        __p[engineId] = _p;
        __s[engineId] = _s;
        return {
            ... state,
            parameterAutomations: __p,
            automationSchedulers: __s,
        };
    case SET_PARAMETER_MIX_AUTOMATIONS:
        engineId = action.payload.parameter.sequencerEngine ?
            action.payload.parameter.sequencerEngine.sequenceId : 0;
        let __p1 = {... state.parameterMixAutomations};
        let __s1 = {... state.automationMixSchedulers};
        let _s1 = state.automationMixSchedulers[engineId] || {};
        let _p1 = state.parameterMixAutomations[engineId] || {};
        _s1[action.payload.parameter.id] = action.payload.scheduler;
        _p1[action.payload.parameter.id] = action.payload.automations;
        __p1[engineId] = _p1;
        __s1[engineId] = _s1;
        return {
            ... state,
            parameterMixAutomations: __p1,
            automationMixSchedulers: __s1
        };
    case SET_AUTOMATION_GUIDE_POINT:
        let guidePoint = {... state.guidePoint};
        guidePoint[action.payload.id] = action.payload.guidePoint;
        return {
            ... state,
            guidePoint 
        };
    case SET_AUTOMATION_POINT_DRAGGING:
        let pointDragging = {... state.pointDragging};
        pointDragging[action.payload.id] = action.payload.point;
        return {
            ... state,
            pointDragging
        };
    case SET_AUTOMATION_POINT_HAS_MOVED:
        let pointHasMoved = {... state.pointHasMoved};
        pointHasMoved[action.payload.id] = action.payload.hasMoved;
        return {
            ... state,
            pointHasMoved
        };
    case SET_AUTOMATION_POINT_HOVERED:
        let pointHovered = {... state.pointHovered};
        pointHovered[action.payload.id] = action.payload.pt;
        return {
            ... state,
            pointHovered
        };
    case SET_AUTOMATION_POINTS_SELECTED:
        let pointsSelected = {... state.pointsSelected};
        pointsSelected[action.payload.id] = action.payload.points;
        return {
            ... state,
            pointsSelected
        };
     case SET_AUTOMATION_SELECTION:
        let selection = {... state.selection};
        selection[action.payload.id] = action.payload.selection;
        return {
            ... state,
            selection: selection
        };
 
   default:
        return state;
    }
};

export default automationReducer;
